// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useMemo } from 'react';

import FadeInSection from 'components/FadeInSection';

import { Container, Wrapper } from './styles';
import { ReactComponent as GraphDesktop } from 'assets/icons/graph-desktop.svg';
import { ReactComponent as GraphMobile } from 'assets/icons/graph-mobile.svg';
import useScreenSize from 'hooks/useScreenSize';

export const MarketSays = () => {
  const screenSize = useScreenSize();

  const isMobileQuery = useMemo(() => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  }, [screenSize]);

  return (
    <Container id={'market-says'}>
      <Wrapper>
        <FadeInSection>
          {isMobileQuery ? (
            <h1>Let's see what the market says</h1>
          ) : (
            <h1>
              Let's see what <br />
              the market says
            </h1>
          )}
        </FadeInSection>
        <FadeInSection>
          {isMobileQuery ? <GraphMobile /> : <GraphDesktop />}
        </FadeInSection>
      </Wrapper>
    </Container>
  );
};
